import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'legal-agreement',
    templateUrl: './legal-agreement.component.html',
    styleUrls: ['./legal-agreement.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LegalAgreementComponent {
  @Input() submitting = false;
  @Output() accepted = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  agreed = false;

  accept() {
    if (!this.agreed || this.submitting) {
      return;
    }

    this.accepted.emit();
  }
}
